
import PageState from "./state"
import mutations from "./mutations"
import {getModule} from '@/store/store'
let APIS = {
  getSpeakerBySearch:`get /apis/tts-web-api/speaker/store/search`
}
export default {
  ...getModule({
    state:new PageState(),
    mutations,
    actions:{},
    APIS,
    name:"searchByname"
  })
}